import React from "react";
import styled from "@emotion/styled";
import {breakpoints, color} from "../../utils/style";
import IcomoonIcon from '../shared/IcomoonIcon';

const showHideChat = (id, frameID) => {
  const chatBox = document.getElementById(id);
  let chatIframe = document.getElementById(frameID);
  chatBox.classList.toggle('open');
  if (chatBox.classList.contains('open')) {
    chatIframe.src = process.env.FRESHCHAT_IFRAME_SRC_NO_BUTTON;
  } else {
    chatIframe.src = 'about:blank';
  }
};

const Wrap = styled('div')`  
  .live-chat-popup {
    height: 880px;
    width: 420px;
    position:fixed;
    right:4px;
    bottom:0;
    z-index:999;
    overflow:hidden;
    display: none;
      
    iframe {
      position: absolute;
      bottom: 0;
      right: -5px;
      width: 1280px;
      height: 730px;
      border: 0;
    }
  }
  
  .above-chat {
    display: none;
  }
    
  &.open {
    bottom: 0;
    .live-chat-popup {
      display: block;
    }
    .live-chat {
      display: none;
    }
  }
  
  @media (max-width: ${breakpoints.md}) {
    .live-chat { display: none; }
    .live-chat-popup {
      position: fixed;
      height: 100%;
      width: 100%;
      display: none;
      .close-chat {
        position: absolute;
        right: 10px;
        top: 12px;
        border: 1px solid #f7bc00;
        width: 44px;
        height: 44px;
        font-size: 20px;
        border-radius: 4px;
        z-index: 9999;
        background-color: ${color.white};
        outline: none;
        svg {
          position: absolute;
          top: 13px;
          left: 11px;
        }
      }
      
      .above-chat {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 60px;
        z-index: 9999;
      }

      #chat-frame {
        width: 100%;
        height: 100%;
        background: ${color.purpleGradient};
      }
    }
  }
  
`;

export default () => (
  <Wrap id="chat-wrapper">
    <div className="live-chat-popup" id="live-chat-popup" >
      <iframe id="chat-frame" className="chat-frame" src="about:blank" title="Chat" />
      <div className="above-chat">
        <button id="close-chat-frame-button" className="close-chat"
                onClick={() => showHideChat('chat-wrapper', 'chat-frame')}>
          <IcomoonIcon icon="close" color={color.trueBlack} size={18}/>
        </button>
      </div>

    </div>
  </Wrap>
);